import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule } from '@angular/common/http';
import { NgxElectronModule } from 'ngx-electron';
import { NgxStripeModule } from 'ngx-stripe';
import { TimeagoModule } from 'ngx-timeago';
import { Angular4PaystackModule } from 'angular4-paystack';
import { environment } from '../environments/environment';
import { JSHINT } from 'jshint';
(window as any).JSHINT = JSHINT;
/*
 * ./services
 */
import { PouchService } from './services/pouch-service'; // General Database Service
import { PreviousRouteService } from './services/previous-route-service';
import { ImageService } from './services/image';
import { ChartService } from './services/chart';
import { Functions } from './services/functions';
import { EmojiProvider } from './services/emoji';
import { AddEntityPageModule } from './add-entity/add-entity.module';
import { CountdownModule } from 'ngx-countdown';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons'; //Solid icons
import { far } from '@fortawesome/free-regular-svg-icons'; // Regular icons
import { fab } from '@fortawesome/free-brands-svg-icons'; // Brand icons

@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [BrowserModule, AppRoutingModule, NgxElectronModule, CountdownModule, BrowserModule, BrowserAnimationsModule, HttpClientModule, IonicModule.forRoot(), TimeagoModule.forRoot(), AddEntityPageModule, FontAwesomeModule, Angular4PaystackModule.forRoot('')],
  providers: [{ provide: RouteReuseStrategy, useClass: IonicRouteStrategy }, ChartService, Functions, PouchService, PreviousRouteService, ImageService, EmojiProvider],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(library: FaIconLibrary) {
    library.addIconPacks(fas, far, fab);
  }
}
